module.exports = __webpack_public_path__ + "assets/img/button-loader.b5579985.svg";